// extracted by mini-css-extract-plugin
module.exports = {"drag_icon":"styles_drag_icon__36v6L","component":"styles_component__rHzfY","hovered":"styles_hovered__2CJoX","dragged":"styles_dragged__29vgE"};